export const getQueries =
  (data: any) => async (dispatch: Function, _getState: Function, api: any) => {
    try {
      return await api.get(`events`);
    } catch (err) {
      console.error(err);
      return null;
    }
  };
